function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import memoizee from 'memoizee';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@deephaven/components';
import { vsChevronRight, vsMerge, vsKey } from '@deephaven/icons';
import Log from '@deephaven/log';
import { Picker } from '@deephaven/jsapi-components';
import { TableUtils } from '@deephaven/jsapi-utils';
import { assertNotNull, Pending, PromiseUtils } from '@deephaven/utils';
import "./IrisGridPartitionSelector.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('IrisGridPartitionSelector');
class IrisGridPartitionSelector extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "pending", void 0);
    _defineProperty(this, "tableUtils", void 0);
    _defineProperty(this, "getCachedChangeCallback", memoizee(index => value => this.handlePartitionSelect(index, value), {
      max: 100
    }));
    _defineProperty(this, "getCachedFormatValueCallback", memoizee(index => value => this.getDisplayValue(index, value), {
      max: 100
    }));
    this.handlePartitionTableClick = this.handlePartitionTableClick.bind(this);
    this.handleMergeClick = this.handleMergeClick.bind(this);
    this.handlePartitionSelect = this.handlePartitionSelect.bind(this);
    var model = props.model;
    this.tableUtils = new TableUtils(model.dh);
    this.pending = new Pending();
    this.state = {
      // We start be loading the partition tables, so we should be in a loading state
      isLoading: true,
      baseTable: null,
      keysTable: null,
      partitionTables: null
    };
  }
  componentDidMount() {
    var _this = this;
    return _asyncToGenerator(function* () {
      var model = _this.props.model;
      try {
        var keysTable = yield _this.pending.add(model.partitionKeysTable().then(keyTable => keyTable), t => t.close());
        var baseTable = yield _this.pending.add(model.partitionBaseTable(), t => t.close());
        _this.setState({
          keysTable,
          baseTable,
          isLoading: false
        }, _this.updatePartitionOptions);
      } catch (e) {
        if (!PromiseUtils.isCanceled(e)) {
          // Just re-throw the error if it's not a cancel
          throw e;
        }
      }
    })();
  }
  componentDidUpdate(prevProps) {
    var prevConfig = prevProps.partitionConfig;
    var partitionConfig = this.props.partitionConfig;
    if (prevConfig !== partitionConfig) {
      this.updatePartitionOptions();
    }
  }
  componentWillUnmount() {
    this.pending.cancel();
    var _this$state = this.state,
      keysTable = _this$state.keysTable,
      baseTable = _this$state.baseTable,
      partitionTables = _this$state.partitionTables;
    baseTable === null || baseTable === void 0 || baseTable.close();
    keysTable === null || keysTable === void 0 || keysTable.close();
    partitionTables === null || partitionTables === void 0 || partitionTables.forEach(table => table.close());
  }
  handlePartitionTableClick() {
    log.debug2('handlePartitionTableClick');
    var partitionConfig = this.props.partitionConfig;
    assertNotNull(partitionConfig);
    var newPartitionConfig = _objectSpread({}, partitionConfig);
    // Toggle between Keys and Partition mode
    newPartitionConfig.mode = partitionConfig.mode === 'keys' ? 'partition' : 'keys';
    this.sendUpdate(newPartitionConfig);
  }
  handleMergeClick() {
    log.debug2('handleMergeClick');
    var partitionConfig = this.props.partitionConfig;
    assertNotNull(partitionConfig);
    var newPartitionConfig = _objectSpread({}, partitionConfig);
    // Toggle between Merged and Partition mode
    newPartitionConfig.mode = partitionConfig.mode === 'merged' ? 'partition' : 'merged';
    this.sendUpdate(newPartitionConfig);
  }

  /**
   * Handles when a partition dropdown selection is changed. Will send an update with the new partition config
   * @param index Index of the partition column that was changed
   * @param selectedValue Selected value of the partition column
   */
  handlePartitionSelect(index, selectedValue) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      var prevConfig = _this2.props.partitionConfig;
      assertNotNull(prevConfig);
      log.debug('handlePartitionSelect', index, selectedValue, prevConfig);
      var newPartitions = [...prevConfig.partitions];
      newPartitions[index] = selectedValue;
      var baseTable = _this2.state.baseTable;
      var keysTable = _this2.state.keysTable;
      assertNotNull(baseTable);
      assertNotNull(keysTable);
      try {
        _this2.setState({
          isLoading: true
        });
        var t = yield _this2.pending.add(baseTable.copy(), tCopy => tCopy.close());

        // Apply our partition filters, and just get the first value
        var partitionFilters = newPartitions.slice(0, index + 1).map((partition, i) => {
          var partitionColumn = t.columns[i];
          return _this2.tableUtils.makeNullableEqFilter(partitionColumn, partition);
        });
        t.applyFilter(partitionFilters);
        t.setViewport(0, 0, t.columns);
        var data = yield _this2.pending.add(t.getViewportData());
        var newConfig = {
          // Core JSAPI returns undefined for null table values,
          // coalesce with null to differentiate null from no selection in the dropdown
          // https://github.com/deephaven/deephaven-core/issues/5400
          partitions: keysTable.columns.map(column => data.rows[0].get(column)),
          mode: 'partition'
        };
        t.close();
        _this2.sendUpdate(newConfig);
      } catch (e) {
        if (!PromiseUtils.isCanceled(e)) {
          log.error('Unable to get partition tables', e);
        }
      } finally {
        _this2.setState({
          isLoading: false
        });
      }
    })();
  }
  sendUpdate(partitionConfig) {
    log.debug2('sendUpdate', partitionConfig);
    var onChange = this.props.onChange;
    onChange(partitionConfig);
  }

  /**
   * Calls model.displayString with a special character case
   * @param index The index of the partition column to get the display value for
   * @param value The partition value to get the display value for
   */
  getDisplayValue(index, value) {
    var model = this.props.model;
    if (value === null) {
      return '(null)';
    }
    if (value === undefined || value === '') {
      return '';
    }
    var column = model.partitionColumns[index];
    if (TableUtils.isCharType(column.type) && value.toString().length > 0) {
      return String.fromCharCode(parseInt(value.toString(), 10));
    }
    return model.displayString(value, column.type, column.name);
  }

  /**
   * Update the options on the partition dropdown tables
   */
  updatePartitionOptions() {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      var model = _this3.props.model;
      var prevConfig = _this3.props.partitionConfig;
      if (prevConfig == null) {
        return;
      }
      var keysTable = _this3.state.keysTable;
      assertNotNull(keysTable);
      var partitionFilters = [...prevConfig.partitions].map((partition, i) => {
        var partitionColumn = keysTable.columns[i];
        return _this3.tableUtils.makeNullableEqFilter(partitionColumn, partition);
      });
      var partitionTables = yield Promise.all(model.partitionColumns.map(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(function* (_, i) {
          keysTable.applyFilter(partitionFilters.slice(0, i));
          return keysTable.selectDistinct(model.partitionColumns.slice(0, i + 1));
        });
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }()));
      _this3.setState({
        partitionTables
      });
    })();
  }
  getPartitionFilters(partitionTables) {
    var _this$props = this.props,
      model = _this$props.model,
      partitionConfig = _this$props.partitionConfig;
    assertNotNull(partitionConfig);
    var partitions = partitionConfig.partitions;
    log.debug('getPartitionFilters', partitionConfig);
    if (partitions.length !== partitionTables.length) {
      throw new Error("Invalid partition config set. Expected ".concat(partitionTables.length, " partitions, but got ").concat(partitions.length));
    }

    // The filters are applied in order, so we need to build up the filters for each partition
    var partitionFilters = [];
    for (var i = 0; i < partitions.length; i += 1) {
      if (i === 0) {
        // There's no reason to ever filter the first table
        partitionFilters.push([]);
      } else {
        var previousFilter = partitionFilters[i - 1];
        var previousPartition = partitions[i - 1];
        var previousColumn = model.partitionColumns[i - 1];
        var partitionFilter = [...previousFilter, this.tableUtils.makeNullableEqFilter(previousColumn, previousPartition)];
        partitionFilters.push(partitionFilter);
      }
    }
    return partitionFilters;
  }
  render() {
    var _this$props2 = this.props,
      model = _this$props2.model,
      partitionConfig = _this$props2.partitionConfig;
    var _this$state2 = this.state,
      isLoading = _this$state2.isLoading,
      partitionTables = _this$state2.partitionTables;
    var partitionSelectors = model.partitionColumns.map((column, index) => /*#__PURE__*/_jsxs("div", {
      className: "column-selector",
      children: [(partitionTables === null || partitionTables === void 0 ? void 0 : partitionTables[index]) && /*#__PURE__*/_jsx(Picker, {
        label: column.name,
        labelPosition: "side",
        table: partitionTables[index],
        direction: "bottom",
        shouldFlip: false,
        keyColumn: partitionTables[index].columns[index].name,
        selectedKey: (partitionConfig === null || partitionConfig === void 0 ? void 0 : partitionConfig.mode) === 'partition' ? partitionConfig.partitions[index] : null,
        placeholder: "Select a key",
        labelColumn: partitionTables[index].columns[index].name,
        onChange: this.getCachedChangeCallback(index),
        isDisabled: isLoading || partitionConfig == null
      }), model.partitionColumns.length - 1 === index || /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: vsChevronRight
      })]
    }, "selector-".concat(column.name)));
    return /*#__PURE__*/_jsxs("div", {
      className: "iris-grid-partition-selector",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "partition-button-group",
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: this.handlePartitionTableClick,
          kind: "inline",
          tooltip: model.isPartitionAwareSourceTable ? 'View keys as table' : 'View underlying partition table',
          icon: vsKey,
          active: (partitionConfig === null || partitionConfig === void 0 ? void 0 : partitionConfig.mode) === 'keys',
          disabled: isLoading || partitionConfig == null,
          children: "Partitions"
        }), /*#__PURE__*/_jsx(Button, {
          onClick: this.handleMergeClick,
          kind: "inline",
          tooltip: "View all partitions as one merged table",
          icon: /*#__PURE__*/_jsx(FontAwesomeIcon, {
            icon: vsMerge,
            rotation: 90
          }),
          active: (partitionConfig === null || partitionConfig === void 0 ? void 0 : partitionConfig.mode) === 'merged',
          disabled: isLoading || partitionConfig == null,
          children: model.isPartitionAwareSourceTable ? 'Coalesce' : 'Merge'
        })]
      }), partitionSelectors]
    });
  }
}
export default IrisGridPartitionSelector;
//# sourceMappingURL=IrisGridPartitionSelector.js.map